const theme = {
  colors: {
    primary: '#1C124A',  // Capture Celebration indigo
    secondary: '#08786D', // Accessible teal
    accent: '#D8B45B',    // Restrained gold
    background: {
      primary: '#FFFFFF',
      card: '#FFFAF2',
      input: '#FFFFFF',
      header: '#FFFFFF',
      hover: '#F5EDE1',
      main: '#FFFFFF'
    },
    text: {
      primary: '#241B3C',
      secondary: '#625B6B',
      accent: '#1C124A',
      placeholder: '#B2BEC3'
    },
    error: {
      main: '#FF7675',
      text: '#D63031',
      background: '#FFE9E9',
      border: '#FFA8A8'
    },
    success: {
      main: '#00B894',
      text: '#00B894',
      background: '#E6FCF5',
      border: '#96F2D7'
    },
    warning: '#FFEAA7',
    info: '#74B9FF',
    border: {
      light: '#DCD4C8',
      hover: '#C9BFAD',
      focus: '#08786D'
    }
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px'
  },
  borderRadius: {
    sm: '8px',    // Increased roundness
    md: '12px',   // Increased roundness
    lg: '16px'    // Increased roundness
  },
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSizes: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.25rem',
      xl: '1.5rem',
      xxl: '2rem',
      base: '1rem'
    },
    fontWeights: {
      light: 300,
      regular: 400,
      medium: 500,
      bold: 700
    },
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400,
    },
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1200px',
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  },
  shadows: {
    sm: '0 2px 4px rgba(0,0,0,0.06)',
    md: '0 4px 12px rgba(0,0,0,0.08)',
    lg: '0 8px 16px rgba(0,0,0,0.08)',
    card: '0 4px 12px rgba(0,0,0,0.1)',
    hover: '0 8px 24px rgba(0,0,0,0.12)'
  },
  zIndices: {
    header: 1000,
    modal: 2000,
    tooltip: 3000
  },
  transitions: {
    fast: '0.2s',
    medium: '0.3s',
    slow: '0.5s',
    default: '0.3s'
  }
} as const;

export type Theme = typeof theme;
export default theme; 